// extracted by css-extract-rspack-plugin
export default {"Schedule":"kl5h1","ControlGroup":"uhKPZ","TextInFirstColumn":"yO183","TextInSecondColumn":"jZwPC","CompactLabels":"OOrGv"};